import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24df118b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "u-anchor" }
const _hoisted_2 = { class: "toc-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "toc-content-heading" }, "目录", -1))
const _hoisted_4 = { class: "toc-items" }
const _hoisted_5 = ["onClick"]

import { onMounted, onUnmounted, ref } from 'vue'

interface Props {
  // 指定监听的容器
  container: string
  // 滚动轴
  target?: string
  // 距离窗口顶部达到指定偏移量
  targetOffset?: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'anchor',
  props: {
    container: null,
    target: null,
    targetOffset: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { container: string, target?: string, targetOffset: number }



const active = ref(0)
const navs = ref({} as NodeListOf<HTMLDivElement>)
const target = ref({} as Element | Window)

const d1 = (val: string) => {
  switch (val) {
    case 'H1':
    case 'H2':
      return 'd2'
    case 'H3':
      return 'd3'
    default:
      return 'd4'
  }
}

// 滚动监听器
const onScroll = () => {
  // 所有锚点元素的 offsetTop
  const offsetTopArr: number[] = []
  navs.value.forEach(v => {
    offsetTopArr.push(v.offsetTop)
  })

  let scroll = target.value instanceof Element ? target.value.scrollTop : undefined

  // 获取当前文档流的 scrollTop
  const scrollTop = scroll || document.documentElement.scrollTop || document.body.scrollTop
  // 定义当前点亮的导航下标
  offsetTopArr.forEach((v, k) => {
    if (scrollTop >= v - 10 - props.targetOffset) {
      active.value = k
    }
  })
}

// 跳转到指定索引的元素
const scrollTo = (k: number) => {
  const tar = navs.value.item(k)
  if (props.target) {
    target.value.scrollTo({
      top: tar.offsetTop - props.targetOffset,
      behavior: 'smooth'
    })
  } else {
    document.documentElement.scrollTo({
      top: tar.offsetTop - props.targetOffset,
      behavior: 'smooth'
    })
  }
}

onMounted(() => {
  if (props.target) {
    target.value = document.querySelector(props.target) as Element
  } else {
    target.value = window
  }
  // 获取所有锚点元素
  navs.value = document
    .querySelector(props.container)
    ?.querySelectorAll('h1, h2, h3, h4, h5, h6') as NodeListOf<HTMLDivElement>
  target.value.addEventListener('scroll', onScroll)
})

onUnmounted(() => {
  target.value.removeEventListener('scroll', onScroll)
})

return (_ctx: any,_cache: any) => {
  const _component_u_divider = _resolveComponent("u-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_u_divider),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navs.value, (v, k) => {
          return (_openBlock(), _createElementBlock("li", {
            key: k,
            class: _normalizeClass([{ active: active.value == k }, d1((v as HTMLDivElement).nodeName)]),
            onClick: ($event: any) => (scrollTo(k as number))
          }, _toDisplayString((v as HTMLDivElement).innerText), 11, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}
}

})